"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contextUtils = void 0;
const cls = require("cls-hooked");
const CLS_NAMESPACE = "DELIVERR";
const ADDITIONAL_LOG_ATTRIBUTES = "ADDITIONAL_LOG_ATTRIBUTES";
function withContext(fn, contextMap) {
    return getNamespace().runAndReturn(function runWithContext() {
        Object.entries(contextMap).forEach(([key, value]) => getNamespace().set(key, value));
        return fn();
    });
}
function getContext(key) {
    return getNamespace().get(key);
}
function setContext(key, value) {
    return getNamespace().set(key, value);
}
function getNamespace() {
    return cls.getNamespace(CLS_NAMESPACE) || cls.createNamespace(CLS_NAMESPACE);
}
function getAdditionalLogAttributes() {
    return getNamespace().get(ADDITIONAL_LOG_ATTRIBUTES) || {};
}
function addAdditionalLogAttribute(key, value) {
    const additionalLogAttributes = getAdditionalLogAttributes();
    additionalLogAttributes[key] = value;
    getNamespace().set(ADDITIONAL_LOG_ATTRIBUTES, additionalLogAttributes);
}
function removeAdditionalLogAttribute(key) {
    const additionalLogAttributes = getAdditionalLogAttributes();
    delete additionalLogAttributes[key];
    getNamespace().set(ADDITIONAL_LOG_ATTRIBUTES, additionalLogAttributes);
}
exports.contextUtils = {
    getNamespace,
    withContext,
    getContext,
    setContext,
    getAdditionalLogAttributes,
    addAdditionalLogAttribute,
    removeAdditionalLogAttribute,
    bindEmitter: getNamespace().bindEmitter.bind(getNamespace()),
    bind: getNamespace().bind.bind(getNamespace()),
};
//# sourceMappingURL=ContextUtils.js.map